"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
var carPoliciesSlice_1 = require("./carPoliciesSlice");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return carPoliciesSlice_1.default; } });
__exportStar(require("./carPoliciesSlice"), exports);
//# sourceMappingURL=index.js.map